import { render } from "./Tile.vue?vue&type=template&id=07c8323a&scoped=true"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"

import "./Tile.vue?vue&type=style&index=0&id=07c8323a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07c8323a"

export default script